import { getField, updateField } from 'vuex-map-fields';
import { WEB_BASE_PATH } from '@/api/path';
import {
  updateOpportunityOrderInfo,
  updateOppoIDandTransactionID,
  getOppAmount,
} from '@/api';
import {
  createLinePayTransaction,
  confirmLinePayTransaction,
} from '@/api/LINEPay';

export default {
  namespaced: true,

  state: {
    oppoId: '', // 捐款ID (saleforce 提供)
    transactionId: '', // 交易ID (LINE 提供)
    amount: '', // 捐款金額
    paymentUrl: { // 捐款連結
      web: '',
      app: '',
    },
    result: '',
    errorMessage: '',
  },

  mutations: {
    updateField,

    updateOppoId(state, oppoId) {
      state.oppoId = oppoId;
    },

    updateTransaction(state, { transactionId, paymentUrl }) {
      state.transactionId = transactionId;
      state.paymentUrl.web = paymentUrl.web;
      state.paymentUrl.app = paymentUrl.app;
    },

    updateAmountAndOppoId(state, { amount, oppoId }) {
      state.amount = amount;
      state.oppoId = oppoId;
    },

    updateResult(state, result) {
      state.result = result;
    },
  },

  getters: {
    getField,
    lineDonationResult(state) {
      const fields = [];

      fields.push({
        name: '捐款編號',
        value: state.oppoId,
      });

      if(state.amount) {
        fields.push({
          name: '付款金額',
          value: state.amount,
        });
      }

      fields.push({
        name: '付款方式',
        value: 'LINE Pay',
      });

      fields.push({
        name: '捐款結果',
        value: state.result,
      });

      return fields;
    },
  },

  actions: {
    async getPaymentUrl({ state, dispatch }) {
      try {
        await dispatch('createLinePayTransaction');
        await dispatch('updateOppoIDandTransactionID');
        return state.paymentUrl;
      } catch(e) {
        console.error('Error: Cant get Line Payment URL');
        alert('Error: Cant get Line Payment URL');
      }
    },

    async createLinePayTransaction({ state, rootState, commit }) {
      try {
        const confirmUrl = `${ WEB_BASE_PATH }/single/result`;
        const payload = {
          amount: rootState.donation.amount,
          productName: '單次捐款',
          orderId: state.oppoId,
          currency: 'TWD',
          confirmUrl: confirmUrl,
          cancelUrl: confirmUrl,
        };
        const result = await createLinePayTransaction(payload);
        // 以下這行是必要的，因為在JSON.parse後LINE傳送的transactionId是19位數，因此會有overflow問題，必須先當成字串擷取
        const index = result.data.indexOf('transactionId');
        // 請注意不要直接寫成const transactionId = result.data.info.transactionId;
        const transactionId = result.data.slice(index + 15, index + 34);
        const paymentUrl = JSON.parse(result.data).info.paymentUrl;

        commit('updateTransaction', { transactionId, paymentUrl });
      } catch(err) {
        console.error('Error: Cant create LINE Transaction', err);
      }
    },

    async updateOppoIDandTransactionID({ state }) {
      const payload = {
        oppoId: state.oppoId,
        transactionId: state.transactionId,
      };
      const resp = await updateOppoIDandTransactionID(payload);
      return resp;
    },

    async finishTransaction({ dispatch, commit }) {
      try {
        await dispatch('getOppoAmount');
        const result = await dispatch('confirmTransaction');
        await dispatch('updateOpportunityOrderInfo', result);
        commit('donation/submittingSuccess', null, { root: true });
      } catch(e) {
        alert(e);
      }
    },

    async getOppoAmount({ state, commit }) {
      const payload = {
        transactionId: state.transactionId,
      };
      const resp = await getOppAmount(payload);
      const amount = resp.data['Amount'];
      const oppoId = resp.data['OppoId'];
      if(amount && oppoId) {
        commit('updateAmountAndOppoId', { amount, oppoId });
      }
    },

    async confirmTransaction({ state }) {
      try {
        const {
          amount,
          transactionId,
        } = state;
        if(!amount || !transactionId) throw new Error('parameter error.');
        const payload = {
          amount: state.amount,
          transactionId: state.transactionId,
        };
        const resp = await confirmLinePayTransaction(payload);
        return resp.data;
      } catch(err) {
        console.error(err);
        return {
          'errorMessage': '沒有獲得amount和transactionId',
        };
      }
    },

    async updateOpportunityOrderInfo({ state, commit }, result) {

      // 為了避免使用者 refresh 頁面，如果已經打過去後端，就不要再打一次
      if(localStorage.getItem(`${state.oppoId}_updated`)) {
        throw new Error('此交易過去已捐款成功，請勿重複刷新頁面');
      }

      try {
        const statusCode = result?.statusCode;
        const response = JSON.parse(result?.response || '{}');
        const now = new Date();

        const payload = {
          oppoID: state.oppoId,
          oppoOrderType: 'LINE',
          oppoCloseDate: `${ now.getFullYear() }-${ now.getMonth() + 1 }-${ now.getDate() }`,
          oppoOrderInfo: '',
          oppoECPayNo: '',
          oppLPStatusCode: statusCode,
          oppLPStatusMsg: result?.errorMessage,
          oppLPTransactionId: (statusCode == '0000') ? state.transactionId : ' ',
          oppLPMaskedCardNum: (statusCode == '0000') ? response.info.payInfo[0].maskedCreditCardNumber : ' ',
          oppLPPayMethod: (statusCode == '0000') ? response.info.payInfo[0].method : ' ',
        };

        const transactionResult = (statusCode == '0000') ? '捐款成功' : `付款失敗 (參考訊息:${ result?.errorMessage })`;
        commit('updateResult', transactionResult);

        // 表示此 oppoID 紀錄已經更新到後端
        localStorage.setItem(`${state.oppoId}_updated`, true);
        const resp = await updateOpportunityOrderInfo(payload);
        if(resp['rtnStatus'] == 'Fail') {
          throw new Error(resp.msg);
        }
        return resp;
      } catch(err) {
        console.error(err);
        alert(err);
      }
    },
  },
};
